import { useEffect, useRef } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import Chip from '@mui/material/Chip';
import { GridFilterInputValueProps, useGridApiContext, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { chipStyles, CHIP_ELIGIBLE_FIELDS } from '../../../utils/helpers';

export const AutoCompleteFilter = (props: GridFilterInputValueProps) => {
  const { applyValue, item } = props;
  const previousOperatorRef = useRef(item.operator);
  const apiRef = useGridApiContext();
  const { valueOptions = [] } = apiRef.current.getColumn(item.field) as GridSingleSelectColDef;
  const isChipEligible = CHIP_ELIGIBLE_FIELDS.includes(item.field as string);

  const handleValueChange = (_e: unknown, newVal: string | string[] | null) => {
    applyValue({ ...item, value: newVal });
  };

  useEffect(() => {
    if (item.operator === 'isAnyOf' && item.value === undefined) applyValue({ ...item, value: [] });
  });

  useEffect(() => {
    const prev = previousOperatorRef.current;
    const curr = item.operator;
    const isSwitchingToMulti = curr === 'isAnyOf' && prev !== 'isAnyOf';
    const isSwitchingToSingle = curr !== 'isAnyOf' && prev === 'isAnyOf';
    if (isSwitchingToMulti || isSwitchingToSingle) {
      const newValue = curr === 'isAnyOf' ? [] : '';
      applyValue({ ...item, value: newValue });
    }

    previousOperatorRef.current = curr;
  }, [item.operator]);

  return (
    <Autocomplete
      id="autocomplete"
      multiple={Array.isArray(item.value)}
      disableCloseOnSelect={Array.isArray(item.value)}
      options={valueOptions as string[]}
      value={item.operator === 'isAnyOf' && Array.isArray(item.value) ? item.value : [item.value]}
      sx={{ marginTop: 'auto', width: '20rem' }}
      renderOption={(optionProps, option) => {
        return (
          <li
            {...optionProps}
            key={option}>
            {isChipEligible ? (
              <Chip
                label={option}
                size="small"
                sx={chipStyles(option)}
              />
            ) : (
              option
            )}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Value"
        />
      )}
      size="small"
      onChange={handleValueChange}
    />
  );
};
